(function () {
	var headertext = [];
	//var headers = document.querySelectorAll("thead");
	var tablebody = document.querySelectorAll("tbody");

	for(var i = 0; i < tablebody.length; i++) {
		headertext[i]=[];
		for (var j = 0, headrow; headrow = tablebody[i].rows[0].cells[j]; j++) {
		  var current = headrow;
		  headertext[i].push(current.textContent.replace(/\r?\n|\r/,""));
		}
	}

	if (tablebody.length > 0) {
		for (var h = 0, tbody; tbody = tablebody[h]; h++) {
			for (var i = 1, row; row = tbody.rows[i]; i++) {
			  for (var j = 0, col; col = row.cells[j]; j++) {
			    col.setAttribute("data-th", headertext[h][j]);
			  }
			}
		}
	}
} ());
